/* eslint-disable */
import {
    createApp
} from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
// import axios from "axios";
// import VueAxios from "vue-axios";
// import VueThreeSixty from "vue-360";

// import "vue-360/dist/css/style.css";
const app = createApp(App);
// app.use(VueThreeSixty);
app.use(store).use(router).mount("#app");